import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@src/design-system/popover';
import { LabelsSelect } from '@src/shared/components/reusables/labels/components/labels-select';
import type { TLabel } from '@src/shared/types/label';
import { useState } from 'react';
import { Tag2 } from 'iconsax-react';
import { TableActionIconButton } from '@src/design-system/molecules/ticlick-table/actions';

const BulkAssignLabels = ({
  bulkAssignLabelFn,
  isAssigningLabelsPending,
}: {
  bulkAssignLabelFn: (labelsIds: number[]) => void;
  isAssigningLabelsPending: boolean;
}) => {
  const [selectedBulkLabels, setSelectedBulkLabels] = useState<TLabel[]>([]);

  return (
    <Popover onOpenChange={(open) => !open && setSelectedBulkLabels([])}>
      <PopoverTrigger asChild>
        <TableActionIconButton
          label='Label'
          className='border-[#FED9B2]'
          icon={
            <Tag2
              className='text-secondary-1000'
              variant='TwoTone'
            />
          }
        />
      </PopoverTrigger>
      <PopoverContent
        withPortal={true}
        side='right'
        align='start'
        className='p-0 w-[370px] rounded-xl'
      >
        <LabelsSelect
          isBulkAssignLabelsPending={isAssigningLabelsPending}
          labels={selectedBulkLabels}
          showSelectedLabels
          onChange={(label) => {
            setSelectedBulkLabels((prev) => {
              const exists = prev.some((l) => l.id === label.id);
              const next = exists
                ? prev.filter((l) => l.id !== label.id)
                : [...prev, label];

              return next;
            });
          }}
          onSaveSelectedLabels={() => {
            const labelIds = selectedBulkLabels.map((l) => l.id);
            bulkAssignLabelFn(labelIds);
          }}
        />
      </PopoverContent>
    </Popover>
  );
};

export default BulkAssignLabels;
